'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ItemCard = require('./ItemCard');

var _ItemCard2 = _interopRequireDefault(_ItemCard);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemGrid = require('./ItemGrid.scss');

var _ItemGrid2 = _interopRequireDefault(_ItemGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemGrid = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ItemGrid, _Component);

    function ItemGrid() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemGrid);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemGrid.__proto__ || (0, _getPrototypeOf2.default)(ItemGrid)).call.apply(_ref, [this].concat(args))), _this), _this.buildItemCards = function (card, index) {
            var _this$props = _this.props,
                cardViewModels = _this$props.cardViewModels,
                hideLotNumbers = _this$props.hideLotNumbers,
                hideSeller = _this$props.hideSeller,
                itemCardClass = _this$props.itemCardClass,
                openAbstenteeBidModal = _this$props.openAbstenteeBidModal,
                openRetractBidModal = _this$props.openRetractBidModal,
                openSendSellerMessageModal = _this$props.openSendSellerMessageModal,
                showBidStatusOnCards = _this$props.showBidStatusOnCards,
                showCtaOnCards = _this$props.showCtaOnCards,
                trackClick = _this$props.trackClick;


            var lastItemIndex = cardViewModels.length - 1;
            var itemCardProps = {
                className: itemCardClass,
                hideLotNumbers: hideLotNumbers,
                hideSeller: hideSeller,
                key: index,
                last: index === lastItemIndex,
                openAbstenteeBidModal: openAbstenteeBidModal,
                openRetractBidModal: openRetractBidModal,
                openSendSellerMessageModal: openSendSellerMessageModal,
                showBidStatus: showBidStatusOnCards,
                showCta: showCtaOnCards
            };
            if (card && !(0, _isEmpty2.default)(card) && !(0, _isEmpty2.default)(card.item)) {
                itemCardProps.cardViewModel = card;
            }
            if (trackClick) {
                itemCardProps.trackClick = function () {
                    return trackClick(card.item.itemId);
                };
            }
            return _react2.default.createElement(_ItemCard2.default, itemCardProps);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemGrid, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['hideLotNumbers', 'className', 'itemCardClass', 'hideLotNumbers', 'showBidStatusOnCards', 'showCtaOnCards', 'cardViewModels']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                cardViewModels = _props.cardViewModels,
                className = _props.className;


            var classes = [].concat((0, _toConsumableArray3.default)(className.split(' ')), [_ItemGrid2.default['item-grid']]).join(' ').trim();
            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, cardViewModels.map(this.buildItemCards));
        }
    }]);
    return ItemGrid;
}(_react.Component), _class.defaultProps = {
    cardViewModels: [],
    className: '',
    hideLotNumbers: false,
    hideSeller: false,
    itemCardClass: '',
    showBidStatusOnCards: false,
    showCtaOnCards: false
}, _temp2);
exports.default = ItemGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemCard/ItemGrid.js
// module id = iLJB
// module chunks = 46